import { Typography } from '@/core/tamagoshiTailwind/components/Typography/Typography';
import {
  subtitle,
  title,
} from '@/domains/retention/Homepage/b2c/modules/SuggestedAndRecentlyViewedProducts/translations';
import { HomepageTertiaryCampaigns } from '@/productDiscovery/CommercialAnimation/components/HomepageCampaigns/HomepageTertiaryCampaigns/HomepageTertiaryCampaigns';
import { useHomepageTertiary } from '@/productDiscovery/CommercialAnimation/hooks/useHomepageTertiary';

export const HomepageTertiaryCampaignsSection = () => {
  const tertiaryCampaigns = useHomepageTertiary();

  return (
    <>
      {tertiaryCampaigns && tertiaryCampaigns.length > 1 && (
        <div
          className="my-l h-full w-full bg-foundation-inverted p-m
            text-foundation-primary desktop:hidden"
        >
          <Typography scale="title3" className="inline-block w-full">
            {title}
          </Typography>
          <Typography
            scale="body2"
            className="mb-m mt-s inline-block w-full text-foundation-secondary"
          >
            {subtitle}
          </Typography>
          <HomepageTertiaryCampaigns />
        </div>
      )}
    </>
  );
};
